import {
  ConnectToCRFProductResponse,
  CRFMatchedLoanProductsResponse,
} from '_types/crfConnect.interface';
import axiosApiInstance from './axiosInstance';

const baseUrl = process.env.REACT_APP_BACKEND_DOMAIN;
const crfConnectService = {
  getCRFLoanProductsList: () =>
    axiosApiInstance
      .get<CRFMatchedLoanProductsResponse>(
        `${baseUrl}/api/v1/crf-connect/sbo/matched-loan-products`,
      )
      .then(({ data }) => data),
  connectToCRFProduct: (productId: number) =>
    axiosApiInstance
      .post<ConnectToCRFProductResponse>(
        `${baseUrl}/api/v1/crf-connect/sbo/products/${productId}/apply`,
      )
      .then(({ data }) => data),
};
export default crfConnectService;
